import { Stack, Typography } from '@mui/material'
import type { FC, ReactNode } from 'react'

export interface Props {
  label: string
  value: string | number
  secondaryValue?: string | number
  icon: ReactNode
  isPrimaryMetric?: boolean
}

const DashbaordStat: FC<Props> = ({
  label,
  value,
  icon,
  secondaryValue,
  isPrimaryMetric = false,
}) => (
  <Stack spacing={1}>
    <Stack direction="row" spacing={1} alignItems="center">
      {icon}
      <Typography component="h6" variant={isPrimaryMetric ? 'h6' : 'subtitle1'}>
        {label}
      </Typography>
    </Stack>
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography component="p" variant={isPrimaryMetric ? 'h4' : 'h5'}>
        {value}
      </Typography>
      <span>{secondaryValue}</span>
    </Stack>
  </Stack>
)

export default DashbaordStat
